import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import ImageUploader from "../../components/common/ImageUploader/ImageUploader";
import eventService from "../../services/event/eventService";
import UploadModules from "../../constants/uploadModules";

import "./Event.css";

export default function EventForm() {

    const navigate = useNavigate();

    const { id } = useParams();

    const isEdit = !!id;

    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({

        eventTitle: "",

        metaTitle: "",

        metaDescription: "",

        shortDescription: "",

        fullDescription: "",

        eventDate: "",

        location: "",

        coverImage: "",

         photos: [],

        displayOrder: 0,

        isActive: true

    });
    const request = {

        eventTitle: form.eventTitle,

        metaTitle: form.metaTitle,

        metaDescription: form.metaDescription,

        shortDescription: form.shortDescription,

        fullDescription: form.fullDescription,

        eventDate: form.eventDate,

        location: form.location,

        coverImage: form.coverImage,

        displayOrder: Number(form.displayOrder),

        isActive: form.isActive

    };

  
    useEffect(() => {

        if (isEdit) {

            loadEvent();

        }

    }, []);

    const loadEvent = async () => {

        try {

            setLoading(true);

            const response = await eventService.getById(id);
            const data = response.data;

            if (response.success) {

                const data = response.data;

                setForm({

                    eventTitle: data.eventTitle || "",

                    metaTitle: data.metaTitle || "",

                    metaDescription: data.metaDescription || "",

                    shortDescription: data.shortDescription || "",

                    fullDescription: data.fullDescription || "",

                    eventDate: data.eventDate
                        ? data.eventDate.substring(0, 10)
                        : "",

                    location: data.location || "",

                    coverImage: data.coverImage || "",

                    photos: data.photos || [],

                    displayOrder: data.displayOrder || 0,

                    isActive: data.isActive

                });
            }

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        setForm({

            ...form,

            [name]: type === "checkbox" ? checked : value

        });

    };


    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!form.eventTitle.trim()) {

            toast.error("Event Title is required.");

            return;

        }

        try {

            setLoading(true);

            let response;

            if (isEdit) {

                response = await eventService.update(id, request);

            }
            else {

                response = await eventService.create(request);

            }
            if (response.success) {

                toast.success(response.message);

                navigate("/events");
            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }
        finally {

            setLoading(false);

        }

    };
    return (

        <AdminLayout>

            <div className="page-header">

                <h2>
                    {isEdit ? "Edit Event" : "Add Event"}
                </h2>

            </div>

            <div className="card">

                <form onSubmit={handleSubmit}>

                    <div className="card-body">

                        <div className="row g-3">

                            {/* News Title */}
                            <div className="col-lg-6">

                                <label className="form-label">
                                    Event Title <span className="text-danger">*</span>
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="eventTitle"
                                    value={form.eventTitle}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-lg-3">

                                <label className="form-label">
                                    Event Date
                                </label>

                                <input
                                    type="date"
                                    className="form-control"
                                    name="eventDate"
                                    value={form.eventDate}
                                    onChange={handleChange}
                                />

                            </div>

                            {/* Display Order */}
                            <div className="col-lg-3">

                                <label className="form-label">
                                    Display Order
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="displayOrder"
                                    value={form.displayOrder}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-lg-7">

                                <label className="form-label">
                                    Location
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="location"
                                    value={form.location}
                                    onChange={handleChange}
                                />

                            </div>


                            {/* Short Description */}
                            <div className="col-6">

                                <label className="form-label">
                                    Short Description
                                </label>

                                <textarea
                                    rows="4"
                                    className="form-control"
                                    name="shortDescription"
                                    value={form.shortDescription}
                                    onChange={handleChange}
                                />

                            </div>

                            {/* Description */}
                            <div className="col-6">

                                <label className="form-label">
                                    Description
                                </label>

                                <textarea
                                    rows="4"
                                    className="form-control"
                                    name="fullDescription"
                                    value={form.fullDescription}
                                    onChange={handleChange}
                                />

                            </div>
                            {/* Image */}
                            <div className="col-lg-6">

                                <label className="form-label">
                                    Cover Image
                                </label>

                                <ImageUploader
                                    module={UploadModules.EVENT}
                                    value={form.coverImage}
                                    onUpload={(path) =>
                                        setForm({
                                            ...form,
                                            coverImage: path
                                        })
                                    }
                                />

                            </div>

                            {/* Status */}
                            <div className="col-lg-2 d-flex align-items-end">

                                <div className="form-check mb-2">

                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="isActive"
                                        name="isActive"
                                        checked={form.isActive}
                                        onChange={handleChange}
                                    />

                                    <label
                                        className="form-check-label"
                                        htmlFor="isActive"
                                    >
                                        Active
                                    </label>

                                </div>

                            </div>

                        </div>

                        <hr />

                        <div className="d-flex justify-content-start gap-2">

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => navigate("/events")}
                            >
                                Cancel
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading
                                    ? "Saving..."
                                    : isEdit
                                        ? "Update"
                                        : "Save"}
                            </button>

                        </div>

                    </div>

                </form>

            </div>
        </AdminLayout>

    );

}